import gql from 'graphql-tag'

export const FOOTER_NAV_LINK_FRAGMENT = gql`
  fragment FooterNavLink on ContentLink {
    openInNewWindow
    text
    url
  }
`

export const FOOTER_NAV_GROUP_FRAGMENT = gql`
  ${FOOTER_NAV_LINK_FRAGMENT}

  fragment FooterNavGroup on FooterNavigationGroup {
    header
    links {
      ...FooterNavLink
    }
  }
`

export const GET_FOOTER_CONTENT = gql`
  ${FOOTER_NAV_GROUP_FRAGMENT}

  query GetFooterContent {
    footer {
      companyInfo
      contactInfo
      navigationGroups {
        ...FooterNavGroup
      }
      socialMediaLinks {
        facebook
        instagram
        linkedIn
        twitter
        youTube
      }
    }
  }
`
